module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j8Iet"))).then(() => parcelRequire('9Lwss'));